import { PlatformUiEnv } from "../platform-ui-envs.type";

export const PlatformUiEnvToHostMap: Record<PlatformUiEnv, string> = {
  local: "http://localhost:3000",
  "platform-prod": "https://platform.goarrowsup.com",
  "platform-dev": "https://platform-dev.goarrowsup.com",
  "platform-legacy": "https://platform-legacy.goarrowsup.com",
};
